import { useState } from 'react';
import { Platform, StyleSheet } from 'react-native';
import { useMaskedInputProps } from 'react-native-mask-input';

import { FormControlTextInput } from '../form-control-text-input';
import { IconMailFilled } from '../icon';

import { EMAIL_INPUT_ACCESSORY_ID } from './name-input';

import { MaskInputProps } from '.';

export function EmailInput(props: MaskInputProps) {
  const [maskedEmail, setMaskedEmail] = useState(props.value);

  const { onChangeText, value: maskedValue } = useMaskedInputProps({
    value: maskedEmail,
    onChangeText: (masked, _unmasked) => {
      setMaskedEmail(masked);
      props.onChange(_unmasked);
    },
  });

  return (
    <FormControlTextInput
      autoCapitalize="none"
      style={styles.input}
      labelStyle={{ marginRight: 'auto' }}
      autoFocus={props.autoFocus}
      error={props.error}
      label={props.label}
      placeholder={'Enter Your Email'}
      keyboardType={Platform.OS === 'web' ? 'default' : 'email-address'}
      autoComplete="email"
      readOnly={props.readOnly}
      leftIcon={<IconMailFilled size={24} />}
      onChangeText={onChangeText}
      onSubmitEditing={props.onSubmitEditing}
      value={maskedValue}
      onBlur={props.onBlur}
      inputAccessoryViewID={EMAIL_INPUT_ACCESSORY_ID}
      required={props.required}
    />
  );
}

const styles = StyleSheet.create({
  input: {
    maxHeight: 48,
    width: '100%',
    ...Platform.select({
      web: {
        flex: 1,
      },
      default: {
        flex: 0,
      },
    }),
  },
});
